import OrderGuideIcon from '@assets/icons/order-guide.svg';
import React from 'react';
import { Button } from '@/components/button';
import { StyleSheet } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  disabled: boolean;
  isAdded: boolean;
  onPress: () => void;
  variantPackUUID: string;
}

const ORDER_GUIDE_BUTTON_HIT_SLOP = {
  bottom: 8,
  left: 16,
  right: 8,
  top: 8,
};

export const OrderGuideButton: React.FC<Props> = ({
  disabled,
  isAdded,
  onPress,
  variantPackUUID,
}) => {
  const theme = useTheme();
  return (
    <Button
      disabled={disabled}
      focusable={false}
      hitSlop={ORDER_GUIDE_BUTTON_HIT_SLOP}
      Icon={OrderGuideIcon}
      iconProps={{
        fill: isAdded ? theme.colors.accent : theme.colors.background,
      }}
      onPress={onPress}
      rounded
      size="small"
      style={[styles.addButton, disabled ? styles.addButtonDisabled : null]}
      testID="order-guide-button"
      trackingData={{
        name: 'item_detail.order_guide_button',
        properties: {
          isAdded,
          variantPackUUID,
        },
      }}
      type="tertiary"
    />
  );
};

const styles = StyleSheet.create({
  addButton: {
    height: 25,
    paddingHorizontal: 0,
    width: 25,
  },
  addButtonDisabled: {
    opacity: 0.4,
  },
});
